export const CATEGORIES = new Map([
  ["Attractions", "150"],
  ["Amusement and Theme Parks", "151"],
  ["Bars & Restaurants", "179"],
  ["Casinos & Gambling", "181"],
  ["Historic Site and Landmark Tours", "153"],
  ["Malls & Shopping Centers", "154"],
  ["Museums & Galleries", "155"],
  ["Nightclubs", "158"],
  ["Outdoor Activities", "159"],
  ["Parks & Nature", "160"],
  ["Theater Venues", "177"],
  ["Zoos & Aquariums", "178"],
  ["Automotive", "1"],
  ["Auto Body Styles", "2"],
  ["Commercial Trucks", "3"],
  ["Convertible", "8"],
  ["Coupe", "9"],
  ["Crossover", "10"],
  ["Hatchback", "11"],
  ["Microcar", "12"],
  ["Minivan", "13"],
  ["Off-Road Vehicles", "14"],
  ["Pickup Trucks", "15"],
  ["Sedan", "4"],
  ["Station Wagon", "5"],
  ["SUV", "6"],
  ["Van", "7"],
  ["Auto Buying and Selling", "30"],
  ["Auto Insurance", "31"],
  ["Auto Parts", "32"],
  ["Auto Recalls", "33"],
  ["Auto Rentals", "41"],
  ["Auto Repair", "34"],
  ["Auto Safety", "35"],
  ["Auto Shows", "36"],
  ["Auto Technology", "37"],
  ["Auto Infotainment Technologies", "38"],
  ["Auto Navigation Systems", "39"],
  ["Auto Safety Technologies", "40"],
  ["Auto Type", "16"],
  ["Budget Cars", "17"],
  ["Certified Pre-Owned Cars", "18"],
  ["Classic Cars", "19"],
  ["Concept Cars", "20"],
  ["Driverless Cars", "21"],
  ["Green Vehicles", "22"],
  ["Luxury Cars", "23"],
  ["Performance Cars", "24"],
  ["Car Culture", "25"],
  ["Dash Cam Videos", "26"],
  ["Motorcycles", "27"],
  ["Road-Side Assistance", "28"],
  ["Scooters", "29"],
  ["Books and Literature", "42"],
  ["Art and Photography", "43"],
  ["Comics and Graphic Novels", "46"],
  ["Fiction", "48"],
  ["Poetry", "49"],
  ["Business and Finance", "52"],
  ["Business", "53"],
  ["Business Accounting & Finance", "54"],
  ["Business Administration", "62"],
  ["Business Banking & Finance", "63"],
  ["Angel Investment", "64"],
  ["Bankruptcy", "65"],
  ["Business Loans", "66"],
  ["Debt Factoring & Invoice Discounting", "67"],
  ["Mergers and Acquisitions", "68"],
  ["Private Equity", "69"],
  ["Sale & Lease Back", "70"],
  ["Venture Capital", "71"],
  ["Business I.T.", "72"],
  ["Business Operations", "73"],
  ["Business Utilities", "79"],
  ["Consumer Issues", "74"],
  ["Recalls", "75"],
  ["Executive Leadership & Management", "76"],
  ["Government Business", "77"],
  ["Green Solutions", "78"],
  ["Human Resources", "55"],
  ["Large Business", "56"],
  ["Logistics", "57"],
  ["Marketing and Advertising", "58"],
  ["Sales", "59"],
  ["Small and Medium-sized Business", "60"],
  ["Startups", "61"],
  ["Economy", "80"],
  ["Commodities", "81"],
  ["Currencies", "82"],
  ["Financial Crisis", "83"],
  ["Financial Reform", "84"],
  ["Financial Regulation", "85"],
  ["Gasoline Prices", "86"],
  ["Housing Market", "87"],
  ["Interest Rates", "88"],
  ["Job Market", "89"],
  ["Industries", "90"],
  ["Advertising Industry", "91"],
  ["Agriculture", "102"],
  ["Apparel Industry", "113"],
  ["Automotive Industry", "117"],
  ["Aviation Industry", "118"],
  ["Biotech and Biomedical Industry", "119"],
  ["Civil Engineering Industry", "120"],
  ["Construction Industry", "121"],
  ["Defense Industry", "122"],
  ["Education industry", "92"],
  ["Entertainment Industry", "93"],
  ["Environmental Services Industry", "94"],
  ["Financial Industry", "95"],
  ["Food Industry", "96"],
  ["Healthcare Industry", "97"],
  ["Hospitality Industry", "98"],
  ["Information Services Industry", "99"],
  ["Legal Services Industry", "100"],
  ["Logistics and Transportation Industry", "101"],
  ["Management Consulting Industry", "103"],
  ["Manufacturing Industry", "104"],
  ["Mechanical and Industrial Engineering Industry", "105"],
  ["Media Industry", "106"],
  ["Metals Industry", "107"],
  ["Non-Profit Organizations", "108"],
  ["Pharmaceutical Industry", "109"],
  ["Power and Energy Industry", "110"],
  ["Publishing Industry", "111"],
  ["Real Estate Industry", "112"],
  ["Retail Industry", "114"],
  ["Technology Industry", "115"],
  ["Telecommunications Industry", "116"],
  ["Careers", "123"],
  ["Apprenticeships", "124"],
  ["Career Advice", "125"],
  ["Career Planning", "126"],
  ["Job Search", "127"],
  ["Job Fairs", "128"],
  ["Resume Writing and Advice", "129"],
  ["Remote Working", "130"],
  ["Vocational Training", "131"],
  ["Communication", "80DV8O"],
  ["Crime", "380"],
  ["Disasters", "381"],
  ["Education", "132"],
  ["Adult Education", "133"],
  ["College Education", "137"],
  ["College Planning", "138"],
  ["Postgraduate Education", "139"],
  ["Professional School", "140"],
  ["Undergraduate Education", "141"],
  ["Early Childhood Education", "142"],
  ["Educational Assessment", "143"],
  ["Standardized Testing", "144"],
  ["Homeschooling", "145"],
  ["Homework and Study", "146"],
  ["Language Learning", "147"],
  ["Online Education", "148"],
  ["Primary Education", "149"],
  ["Private School", "134"],
  ["Secondary Education", "135"],
  ["Special Education", "136"],
  ["Entertainment", "JLBCU7"],
  ["Movies", "324"],
  ["Music", "338"],
  ["Television", "640"],
  ["Events", "8VZQHL"],
  ["Awards Shows", "162"],
  ["Business Expos & Conferences", "180"],
  ["Fan Conventions", "185"],
  ["Family and Relationships", "186"],
  ["Bereavement", "187"],
  ["Dating", "188"],
  ["Divorce", "189"],
  ["Eldercare", "190"],
  ["Marriage and Civil Unions", "191"],
  ["Parenting", "192"],
  ["Adoption and Fostering", "193"],
  ["Daycare and Pre-School", "194"],
  ["Internet Safety", "195"],
  ["Parenting Babies and Toddlers", "196"],
  ["Parenting Children Aged 4-11", "197"],
  ["Parenting Teens", "198"],
  ["Special Needs Kids", "199"],
  ["Single Life", "200"],
  ["Fine Art", "201"],
  ["Costume", "202"],
  ["Dance", "203"],
  ["Design", "204"],
  ["Digital Arts", "205"],
  ["Fine Art Photography", "206"],
  ["Modern Art", "207"],
  ["Opera", "208"],
  ["Theater", "209"],
  ["Food & Drink", "210"],
  ["Alcoholic Beverages", "211"],
  ["Barbecues and Grilling", "215"],
  ["Cooking", "216"],
  ["Desserts and Baking", "217"],
  ["Dining Out", "218"],
  ["Food Allergies", "219"],
  ["Food Movements", "220"],
  ["Healthy Cooking and Eating", "221"],
  ["Non-Alcoholic Beverages", "222"],
  ["Vegan Diets", "212"],
  ["Vegetarian Diets", "213"],
  ["World Cuisines", "214"],
  ["Genres", "SPSHQ5"],
  ["Nature", "VKIV56"],
  ["Action/Adventure", "325"],
  ["Animation & Anime", "641"],
  ["Biographies", "44"],
  ["Comedy", "646"],
  ["Documentary", "332"],
  ["Drama", "647"],
  ["Factual", "648"],
  ["Family/Children", "645"],
  ["Fantasy", "335"],
  ["History", "EZWB7V"],
  ["Holiday", "649"],
  ["Horror", "336"],
  ["Lifestyle", "TIFQA5"],
  ["Music Video", "650"],
  ["Musical", "156"],
  ["Mystery", "331"],
  ["Reality TV", "651"],
  ["Romance", "326"],
  ["Science Fiction", "652"],
  ["Soap Opera", "642"],
  ["Special Interest (Indie/Art House)", "643"],
  ["Sports Radio", "370"],
  ["Talk Radio", "371"],
  ["Public Radio", "376"],
  ["Talk Show", "A0AH3G"],
  ["True Crime", "KHPC5A"],
  ["Western", "KHPC6A"],
  ["Young Adult", "51"],
  ["Thriller", "700"],
  ["Healthy Living", "223"],
  ["Children's Health", "224"],
  ["Fitness and Exercise", "225"],
  ["Participant Sports", "226"],
  ["Running and Jogging", "227"],
  ["Men's Health", "228"],
  ["Nutrition", "229"],
  ["Senior Health", "230"],
  ["Weight Loss", "231"],
  ["Wellness", "232"],
  ["Alternative Medicine", "233"],
  ["Herbs and Supplements", "234"],
  ["Holistic Health", "235"],
  ["Physical Therapy", "236"],
  ["Smoking Cessation", "237"],
  ["Women's Health", "238"],
  ["Hobbies & Interests", "239"],
  ["Antiquing and Antiques", "240"],
  ["Arts and Crafts", "248"],
  ["Beadwork", "249"],
  ["Candle and Soap Making", "250"],
  ["Drawing and Sketching", "251"],
  ["Jewelry Making", "252"],
  ["Needlework", "253"],
  ["Painting", "254"],
  ["Photography", "255"],
  ["Scrapbooking", "256"],
  ["Woodworking", "257"],
  ["Beekeeping", "258"],
  ["Birdwatching", "259"],
  ["Cigars", "260"],
  ["Collecting", "261"],
  ["Comic Books", "262"],
  ["Stamps and Coins", "263"],
  ["Content Production", "264"],
  ["Audio Production", "265"],
  ["Freelance Writing", "266"],
  ["Screenwriting", "267"],
  ["Video Production", "268"],
  ["Games and Puzzles", "269"],
  ["Board Games and Puzzles", "270"],
  ["Card Games", "271"],
  ["Roleplaying Games", "272"],
  ["Genealogy and Ancestry", "273"],
  ["Magic and Illusion", "241"],
  ["Model Toys", "242"],
  ["Musical Instruments", "243"],
  ["Paranormal Phenomena", "244"],
  ["Radio Control", "245"],
  ["Sci-fi and Fantasy", "246"],
  ["Workshops and Classes", "247"],
  ["Holidays", "1KXCLD"],
  ["National & Civic Holidays", "157"],
  ["Home & Garden", "274"],
  ["Gardening", "275"],
  ["Home Appliances", "278"],
  ["Home Entertaining", "279"],
  ["Home Improvement", "280"],
  ["Home Security", "281"],
  ["Indoor Environmental Quality", "282"],
  ["Interior Decorating", "283"],
  ["Landscaping", "284"],
  ["Outdoor Decorating", "285"],
  ["Remodeling & Construction", "276"],
  ["Smart Home", "277"],
  ["Law", "383"],
  ["Medical Health", "286"],
  ["Cosmetic Medical Services", "323"],
  ["Diseases and Conditions", "287"],
  ["Allergies", "288"],
  ["Blood Disorders", "306"],
  ["Bone and Joint Conditions", "312"],
  ["Brain and Nervous System Disorders", "313"],
  ["Cancer", "314"],
  ["Cold and Flu", "315"],
  ["Dental Health", "316"],
  ["Diabetes", "317"],
  ["Digestive Disorders", "318"],
  ["Ear, Nose and Throat Conditions", "289"],
  ["Endocrine and Metabolic Diseases", "290"],
  ["Hormonal Disorders", "291"],
  ["Menopause", "292"],
  ["Thyroid Disorders", "293"],
  ["Eye and Vision Conditions", "294"],
  ["Foot Health", "295"],
  ["Heart and Cardiovascular Diseases", "296"],
  ["Infectious Diseases", "297"],
  ["Injuries", "298"],
  ["First Aid", "299"],
  ["Lung and Respiratory Health", "300"],
  ["Mental Health", "301"],
  ["Reproductive Health", "302"],
  ["Birth Control", "303"],
  ["Infertility", "304"],
  ["Pregnancy", "305"],
  ["Sexual Health", "307"],
  ["Sexual Conditions", "308"],
  ["Skin and Dermatology", "309"],
  ["Sleep Disorders", "310"],
  ["Substance Abuse", "311"],
  ["Medical Tests", "319"],
  ["Pharmaceutical Drugs", "320"],
  ["Surgery", "321"],
  ["Vaccines", "322"],
  ["Adult Album Alternative", "342"],
  ["Adult Contemporary Music", "339"],
  ["Soft AC Music", "340"],
  ["Urban AC Music", "341"],
  ["Alternative Music", "343"],
  ["Blues", "360"],
  ["Children's Music", "344"],
  ["Classic Hits", "345"],
  ["Classical Music", "346"],
  ["College Radio", "347"],
  ["Comedy (Music and Audio)", "348"],
  ["Contemporary Hits/Pop/Top 40", "349"],
  ["Country Music", "350"],
  ["Dance and Electronic Music", "351"],
  ["Gospel Music", "354"],
  ["Hip Hop Music", "355"],
  ["Inspirational/New Age Music", "356"],
  ["Jazz", "357"],
  ["Oldies/Adult Standards", "358"],
  ["R&B/Soul/Funk", "362"],
  ["Reggae", "359"],
  ["Religious (Music and Audio)", "361"],
  ["Rock Music", "363"],
  ["Album-oriented Rock", "364"],
  ["Alternative Rock", "365"],
  ["Classic Rock", "366"],
  ["Hard Rock", "367"],
  ["Soft Rock", "368"],
  ["Songwriters/Folk", "353"],
  ["Soundtracks, TV and Showtunes", "369"],
  ["World/International Music", "352"],
  ["Urban Contemporary Music", "377"],
  ["Variety (Music and Audio)", "378"],
  ["Personal Celebrations & Life Events", "163"],
  ["Anniversary", "164"],
  ["Baby Shower", "166"],
  ["Bachelor Party", "167"],
  ["Bachelorette Party", "168"],
  ["Birth", "169"],
  ["Birthday", "170"],
  ["Funeral", "171"],
  ["Graduation", "172"],
  ["Prom", "173"],
  ["Wedding", "165"],
  ["Personal Finance", "391"],
  ["Consumer Banking", "392"],
  ["Financial Assistance", "393"],
  ["Government Support and Welfare", "394"],
  ["Student Financial Aid", "395"],
  ["Financial Planning", "396"],
  ["Frugal Living", "397"],
  ["Home Utilities", "417"],
  ["Gas and Electric", "418"],
  ["Internet Service Providers", "419"],
  ["Phone Services", "420"],
  ["Water Services", "421"],
  ["Insurance", "398"],
  ["Health Insurance", "399"],
  ["Home Insurance", "400"],
  ["Life Insurance", "401"],
  ["Motor Insurance", "402"],
  ["Pet Insurance", "403"],
  ["Travel Insurance", "404"],
  ["Personal Debt", "405"],
  ["Credit Cards", "406"],
  ["Home Financing", "407"],
  ["Personal Loans", "408"],
  ["Student Loans", "409"],
  ["Personal Investing", "410"],
  ["Hedge Funds", "411"],
  ["Mutual Funds", "412"],
  ["Options", "413"],
  ["Stocks and Bonds", "414"],
  ["Personal Taxes", "415"],
  ["Retirement Planning", "416"],
  ["Pets", "422"],
  ["Birds", "423"],
  ["Cats", "424"],
  ["Dogs", "425"],
  ["Fish and Aquariums", "426"],
  ["Large Animals", "427"],
  ["Pet Adoptions", "428"],
  ["Pet Supplies", "431"],
  ["Reptiles", "429"],
  ["Veterinary Medicine", "430"],
  ["Politics", "386"],
  ["Civic affairs", "8YPBBL"],
  ["Elections", "387"],
  ["Political Issues & Policy", "388"],
  ["Pop Culture", "432"],
  ["Celebrity Deaths", "433"],
  ["Celebrity Families", "434"],
  ["Celebrity Homes", "435"],
  ["Celebrity Pregnancy", "436"],
  ["Celebrity Relationships", "437"],
  ["Celebrity Scandal", "438"],
  ["Celebrity Style", "439"],
  ["Humor and Satire", "440"],
  ["Productivity", "W3CW2J"],
  ["Real Estate", "441"],
  ["Apartments", "442"],
  ["Developmental Sites", "445"],
  ["Hotel Properties", "446"],
  ["Houses", "447"],
  ["Industrial Property", "448"],
  ["Land and Farms", "449"],
  ["Office Property", "450"],
  ["Real Estate Buying and Selling", "451"],
  ["Real Estate Renting and Leasing", "452"],
  ["Retail Property", "443"],
  ["Vacation Properties", "444"],
  ["Religion & Spirituality", "453"],
  ["Agnosticism", "454"],
  ["Astrology", "456"],
  ["Atheism", "457"],
  ["Buddhism", "458"],
  ["Christianity", "459"],
  ["Hinduism", "460"],
  ["Islam", "461"],
  ["Judaism", "462"],
  ["Sikhism", "463"],
  ["Spirituality", "455"],
  ["Science", "464"],
  ["Biological Sciences", "465"],
  ["Chemistry", "466"],
  ["Environment", "467"],
  ["Genetics", "468"],
  ["Geography", "469"],
  ["Geology", "470"],
  ["Physics", "471"],
  ["Space and Astronomy", "472"],
  ["Weather", "390"],
  ["Sensitive Topics", "v9i3On"],
  ["Adult & Explicit Sexual Content", "Rm3SiT"],
  ["Arms & Ammunition", "avbNf2"],
  [
    "Crime & Harmful Acts to Individuals, Society & Human Right Violations",
    "XtODT3",
  ],
  ["Death, Injury, or Military Conflict", "I4GWl6"],
  ["Debated Sensitive Social Issues", "Z7rJBM"],
  ["Hate Speech and Acts of Aggression", "HxqYV1"],
  ["Illegal Drugs, Tobacco, eCigarettes, Vaping, Alcohol", "pg0WhF"],
  ["Obscenity and Profanity", "j9PaO9"],
  ["Online Piracy", "mm3UXx"],
  ["Spam or Harmful Content", "6i4dB6"],
  ["Terrorism", "8FD8nI"],
  ["Shopping", "473"],
  ["Children's Games and Toys", "482"],
  ["Coupons and Discounts", "474"],
  ["Flower Shopping", "475"],
  ["Gifts and Greetings Cards", "476"],
  ["Grocery Shopping", "477"],
  ["Holiday Shopping", "478"],
  ["Household Supplies", "479"],
  ["Lotteries and Scratchcards", "480"],
  ["Party Supplies and Decorations", "161"],
  ["Sales and Promotions", "481"],
  ["Sports", "483"],
  ["American Football", "484"],
  ["Australian Rules Football", "507"],
  ["Auto Racing", "518"],
  ["Motorcycle Sports", "519"],
  ["Badminton", "534"],
  ["Baseball", "545"],
  ["Basketball", "547"],
  ["Beach Volleyball", "548"],
  ["Bodybuilding", "549"],
  ["Bowling", "550"],
  ["Boxing", "485"],
  ["Cheerleading", "486"],
  ["College Sports", "487"],
  ["College Baseball", "490"],
  ["College Basketball", "489"],
  ["College Football", "488"],
  ["Cricket", "491"],
  ["Cycling", "492"],
  ["Darts", "493"],
  ["Disabled Sports", "494"],
  ["Diving", "495"],
  ["Equine Sports", "496"],
  ["Horse Racing", "497"],
  ["Extreme Sports", "498"],
  ["Canoeing and Kayaking", "499"],
  ["Climbing", "500"],
  ["Paintball", "501"],
  ["Scuba Diving", "502"],
  ["Skateboarding", "503"],
  ["Snowboarding", "504"],
  ["Surfing and Bodyboarding", "505"],
  ["Waterskiing and Wakeboarding", "506"],
  ["Fantasy Sports", "508"],
  ["Field Hockey", "509"],
  ["Figure Skating", "510"],
  ["Fishing Sports", "511"],
  ["Golf", "512"],
  ["Gymnastics", "513"],
  ["Hunting and Shooting", "514"],
  ["Ice Hockey", "515"],
  ["Inline Skating", "516"],
  ["Lacrosse", "517"],
  ["Martial Arts", "520"],
  ["Olympic Sports", "521"],
  ["Summer Olympic Sports", "522"],
  ["Winter Olympic Sports", "523"],
  ["Poker and Professional Gambling", "524"],
  ["Rodeo", "525"],
  ["Rowing", "526"],
  ["Rugby", "527"],
  ["Rugby League", "528"],
  ["Rugby Union", "529"],
  ["Sailing", "530"],
  ["Skiing", "531"],
  ["Snooker/Pool/Billiards", "532"],
  ["Soccer", "533"],
  ["Softball", "535"],
  ["Sports Equipment", "551"],
  ["Squash", "536"],
  ["Swimming", "537"],
  ["Table Tennis", "538"],
  ["Tennis", "539"],
  ["Track and Field", "540"],
  ["Volleyball", "541"],
  ["Walking", "542"],
  ["Water Polo", "543"],
  ["Weightlifting", "544"],
  ["Wrestling", "546"],
  ["Style & Fashion", "552"],
  ["Beauty", "553"],
  ["Hair Care", "554"],
  ["Makeup and Accessories", "555"],
  ["Nail Care", "556"],
  ["Natural and Organic Beauty", "557"],
  ["Perfume and Fragrance", "558"],
  ["Skin Care", "559"],
  ["Body Art", "574"],
  ["Children's Clothing", "575"],
  ["Designer Clothing", "576"],
  ["Fashion Trends", "577"],
  ["High Fashion", "578"],
  ["Men's Fashion", "579"],
  ["Men's Accessories", "580"],
  ["Men's Jewelry and Watches", "581"],
  ["Men's Clothing", "582"],
  ["Men's Business Wear", "583"],
  ["Men's Casual Wear", "584"],
  ["Men's Formal Wear", "585"],
  ["Men's Outerwear", "586"],
  ["Men's Sportswear", "587"],
  ["Men's Underwear and Sleepwear", "588"],
  ["Men's Shoes and Footwear", "589"],
  ["Personal Care", "590"],
  ["Bath and Shower", "591"],
  ["Deodorant and Antiperspirant", "592"],
  ["Oral care", "593"],
  ["Shaving", "594"],
  ["Street Style", "595"],
  ["Women's Fashion", "560"],
  ["Women's Accessories", "561"],
  ["Women's Glasses", "562"],
  ["Women's Handbags and Wallets", "563"],
  ["Women's Hats and Scarves", "564"],
  ["Women's Jewelry and Watches", "565"],
  ["Women's Clothing", "566"],
  ["Women's Business Wear", "567"],
  ["Women's Casual Wear", "568"],
  ["Women's Formal Wear", "569"],
  ["Women's Intimates and Sleepwear", "570"],
  ["Women's Outerwear", "571"],
  ["Women's Sportswear", "572"],
  ["Women's Shoes and Footwear", "573"],
  ["Technology & Computing", "596"],
  ["Artificial Intelligence", "597"],
  ["Augmented Reality", "598"],
  ["Computing", "599"],
  ["Computer Networking", "600"],
  ["Computer Peripherals", "601"],
  ["Computer Software and Applications", "602"],
  ["3-D Graphics", "603"],
  ["Antivirus Software", "608"],
  ["Browsers", "609"],
  ["Computer Animation", "610"],
  ["Databases", "611"],
  ["Desktop Publishing", "612"],
  ["Digital Audio", "613"],
  ["Maps & Navigation", "WQC6HR"],
  ["Graphics Software", "614"],
  ["Operating Systems", "615"],
  ["Photo Editing Software", "604"],
  ["Shareware and Freeware", "605"],
  ["Video Software", "606"],
  ["Web Conferencing", "607"],
  ["Data Storage and Warehousing", "616"],
  ["Desktops", "617"],
  ["Information and Network Security", "618"],
  ["Internet", "619"],
  ["Cloud Computing", "620"],
  ["Email", "623"],
  ["Internet for Beginners", "624"],
  ["Internet of Things", "625"],
  ["IT and Internet Support", "626"],
  ["Search", "627"],
  ["Social Networking", "628"],
  ["Web Design and HTML", "629"],
  ["Web Development", "621"],
  ["Web Hosting", "622"],
  ["Laptops", "630"],
  ["Programming Languages", "631"],
  ["Consumer Electronics", "632"],
  ["Cameras and Camcorders", "633"],
  ["Home Entertainment Systems", "634"],
  ["Smartphones", "635"],
  ["Tablets and E-readers", "636"],
  ["Wearable Technology", "637"],
  ["Robotics", "638"],
  ["Virtual Reality", "639"],
  ["Travel", "653"],
  ["Travel Accessories", "654"],
  ["Travel Locations", "655"],
  ["Africa Travel", "656"],
  ["Asia Travel", "657"],
  ["Australia and Oceania Travel", "658"],
  ["Europe Travel", "659"],
  ["North America Travel", "660"],
  ["Polar Travel", "661"],
  ["South America Travel", "662"],
  ["Travel Preparation and Advice", "663"],
  ["Travel Type", "664"],
  ["Adventure Travel", "665"],
  ["Air Travel", "672"],
  ["Beach Travel", "673"],
  ["Bed & Breakfasts", "674"],
  ["Budget Travel", "675"],
  ["Business Travel", "676"],
  ["Camping", "677"],
  ["Cruises", "678"],
  ["Day Trips", "679"],
  ["Family Travel", "666"],
  ["Honeymoons and Getaways", "667"],
  ["Hotels and Motels", "668"],
  ["Rail Travel", "669"],
  ["Road Trips", "670"],
  ["Spas", "671"],
  ["Video Gaming", "680"],
  ["Console Games", "681"],
  ["eSports", "682"],
  ["Mobile Games", "683"],
  ["PC Games", "684"],
  ["Video Game Genres", "685"],
  ["Action Video Games", "686"],
  ["Action-Adventure Video Games", "691"],
  ["Adult Video Games", "MQ2XML"],
  ["Adventure Video Games", "692"],
  ["Casino and Gambling Video Games", "ZJG29S"],
  ["Casual Games", "693"],
  ["Educational Video Games", "694"],
  ["Exercise and Fitness Video Games", "695"],
  ["Family Video Games", "VWGKS7"],
  ["Horror Video Games", "II436J"],
  ["MMOs", "696"],
  ["Music and Party Video Games", "697"],
  ["Puzzle Video Games", "698"],
  ["Racing Video Games", "VK7KD0"],
  ["Role-Playing Video Games", "687"],
  ["Simulation Video Games", "688"],
  ["Sports Video Games", "689"],
  ["Strategy Video Games", "690"],
  ["War and Conflicts", "389"],
]);
